// extracted by mini-css-extract-plugin
module.exports = {"bodyScroll":"_1Ksd5-ZaFJp9qVJJDWoANq"};